import index from '@/store/index';

export default {
  goto_qunit(router, qunit, centro_id) {
    /**
     * Navegate to the explorer Table focusing QUnit
     */
    router.push({
      path: 'explorer',
      query: {
      },
    });
    router.push({
      path: 'explorer',
      query: {
        business_process: qunit.business_process,
        pk: qunit.uid
      },
    });

    if (centro_id && centro_id != index.getters.centro_id) {
      index.dispatch('GOTO_CENTRO',{centro_id: centro_id, context: this}).then(()=>{
        router.go();
      })
    }
  },
  goto_qunit_by_uid(router, uid, centro_id) {
    /**
     * Navegate to the explorer Table focusing QUnit
     */
    router.push({
      path: 'explorer',
      query: {
      },
    });
    router.push({
      path: 'explorer',
      query: {
        business_process: uid.split('#')[1],
        pk: uid
      },
    });
    
    if (centro_id && centro_id != index.getters.centro_id) {
      index.dispatch('GOTO_CENTRO',{centro_id: centro_id, context: this}).then(()=>{
        router.go();
      })
    }
  },
};
